import { useState } from 'react';
import { Link } from 'react-router-dom';

import useAuthentication from '../../hooks/useAuthentication';
import useUserManagement from '../../hooks/useUserManagement';
import InfoModal from '../psc/lib/InfoModal';

const Footer = () => {
    const { currentUser } = useAuthentication();

    const { userShowNavigation } = useUserManagement();

    const [showHelpModal, setShowHelpModal] = useState(false);

    if (!userShowNavigation(currentUser)) {
        return null;
    }

    return (
        <>
            <div className="footer d-flex justify-content-between align-items-center">
                <div>
                    Copyright <a href="https://gncgo.space/" target="_blank" rel="noreferrer">GNC Space</a> &copy; 2017 - 2026
                </div>
                <div className="pointer link-gncgo" onClick={() => setShowHelpModal(true)}>
                    <i className="fa fa-question-circle"></i> Need help? 
                </div>
                <div className="pull-right">
                    <Link to="/changelog">
                        <i className="fa fa-rocket"></i> Changelog
                    </Link>
                </div>
            </div>
            <InfoModal
                titleIcon="fa fa-question-circle"
                title="Need help?"
                bodyContent={
                    <>
                        <div>
                            The GNC Go knowledge base is available <a href="https://support.gncgo.space/" target="_blank" rel="noreferrer">here</a>.
                        </div>
                        <div>
                            If you can't find what you're looking for, please send us an email at <a href="mailto:support@gncgo.com">support@gncgo.com</a>.
                        </div>
                    </>
                }
                show={showHelpModal}
                onClose={() => setShowHelpModal(false)}
            />
        </>
    );
};

export default Footer;
